export function getSafeReturnPath(
  returnPath: string | null,
  fallback: string
): string {
  if (
    returnPath &&
    returnPath.startsWith("/") &&
    !returnPath.startsWith("//")
  ) {
    return returnPath;
  }
  return fallback;
}
